import { useEffect, useRef, useState } from "react";
import socketIOClient from "socket.io-client";
import { v4 as uuidv4 } from "uuid";

const NEW_CHAT_MESSAGE_EVENT = "newChatMessage";
const DELETE_CHAT_MESSAGE_EVENT = "deleteChatMessage";
const SOCKET_SERVER_URL = "https://swipewall.azurewebsites.net";
// const SOCKET_SERVER_URL = "http://localhost:8080/";

const useChat = (roomId) => {
  const [messages, setMessages] = useState([]);
  const socketRef = useRef();

  useEffect(() => {
    const localMessages = localStorage.getItem("messages");
    try {
      if (JSON.parse(localMessages).length > 0) {
        setMessages(JSON.parse(localMessages));
      }
    } catch (e) {
      console.log(e);
    }
  }, []);

  useEffect(() => {
    messages.length > 0 &&
      localStorage.setItem("messages", JSON.stringify([...messages]));
  }, [messages]);

  useEffect(() => {
    socketRef.current = socketIOClient(SOCKET_SERVER_URL, {
      query: { roomId },
    });

    socketRef.current.on(NEW_CHAT_MESSAGE_EVENT, (message) => {
      const incomingMessage = {
        ...message,
        ownedByCurrentUser: message.senderId === socketRef.current.id,
      };
      setMessages((messages) => [...messages, incomingMessage]);
    });

    socketRef.current.on(DELETE_CHAT_MESSAGE_EVENT, (message) => {
      if (message.id == "ALL") {
        setMessages([]);
        localStorage.removeItem("messages");
      } else {
        setMessages((messages) => [
          ...messages.filter((x) => x?.id != message?.id),
        ]);
      }
    });

    return () => {
      socketRef.current.disconnect();
    };
  }, [roomId]);

  const sendMessage = (messageBody) => {
    socketRef.current.emit(NEW_CHAT_MESSAGE_EVENT, {
      body: messageBody,
      senderId: socketRef.current.id,
      id: uuidv4(),
    });
  };

  const deleteMessage = (messageBody) => {
    socketRef.current.emit(DELETE_CHAT_MESSAGE_EVENT, messageBody);
  };

  const deleteAllMessage = (messageBody) => {
    messageBody.id = "ALL";
    socketRef.current.emit(DELETE_CHAT_MESSAGE_EVENT, messageBody);
  };

  return { messages, sendMessage, setMessages, deleteMessage };
};

export default useChat;
